import { useAuth } from '@/features/auth/hooks/use-auth';

/**
 * Quién puede CREAR una estrategia: los mismos roles que el backend
 * (`puedeAplicar`, `strategy-applications.routes.ts:54`). La pestaña Estrategias
 * se ve igual para todos (ruling M7: no se candadea por rol); lo que no se
 * ofrece es el botón que terminaría en 403 al final del paso 3.
 */
export const ROLES_QUE_CREAN_ESTRATEGIAS = ['PLATFORM_ADMIN', 'COMPANY_ADMIN', 'APPROVER'] as const;

export function puedeCrearEstrategias(role: string | null | undefined): boolean {
  return (ROLES_QUE_CREAN_ESTRATEGIAS as readonly string[]).includes(role ?? '');
}

export function usePuedeCrearEstrategias(): boolean {
  const { user } = useAuth();
  return puedeCrearEstrategias(user?.role);
}
